import BeEndpoints from '../../services/end-points/be-endpoints';
import requestService from '../services/requestService';

export const sendOTPController = (data, query) => {
  const request = {
    method: 'post',
    url: BeEndpoints.SEND_OTP_NTB,
    data,
  };
  return requestService(query, request, (d) => d.data);
};

export const verifyOTPController = (data, query) => {
  const request = {
    method: 'post',
    url: BeEndpoints.VERIFY_OTP_NTB,
    data,
  };
  return requestService(query, request, (d) => d.data);
};

export const lenderListController = (data, query) => {
  const request = {
    method: 'post',
    url: BeEndpoints.ELIGIBILITY_LIST,
    data,
  };
  return requestService(query, request, (d) => d.data);
};

export const getMarketPlaceInfo = (data, query) => {
  const request = {
    method: 'post',
    url: `${BeEndpoints.NTB_BENEFITS_INFO}`,
    data,
  };
  return requestService(query, request, (d) => d.data);
};

export const sendSMSLinkController = (data, query) => {
  const request = {
    method: 'post',
    url: BeEndpoints.WIDGET_SEND_APP_SMS,
    data,
  };
  return requestService(query, request, (d) => d.data);
};

export const initiateLenderNTB = (data, query) => {
  const request = {
    method: 'post',
    url: `${BeEndpoints.INITIATE_LENDER_NTB}`,
    data,
  };

  return requestService(query, request, (d) => d.data);
};

export const getNtbLenderList = (data, query) => {
  const request = {
    method: 'post',
    url: `${BeEndpoints.NTB_LENDER_LIST}`,
    data,
  };
  return requestService(query, request, (d) => d.data);
};

export const getNtbLenderStatus = (data, query) => {
  const request = {
    method: 'post',
    url: `${BeEndpoints.NTB_LENDER_STATUS}`,
    data,
  };
  return requestService(query, request, (d) => d.data);
};

export const sendNtbSMSLinkController = (data, query) => {
  const request = {
    method: 'post',
    url: BeEndpoints.NTB_SEND_APP_SMS,
    data,
  };
  return requestService(query, request, (d) => d.data);
};

export const getLenderPreEligibility = (data, query) => {
  const request = {
    method: 'post',
    url: BeEndpoints.NTB_LENDER_PRE_ELIGIBILITY,
    data,
  };
  return requestService(query, request, (d) => d.data);
};



// WEBPACK FOOTER //
// ./api/controllers/ntbController.js